import { render, staticRenderFns } from "./AddTeamMemberModal.vue?vue&type=template&id=66004128&"
import script from "./AddTeamMemberModal.vue?vue&type=script&lang=js&"
export * from "./AddTeamMemberModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66004128')) {
      api.createRecord('66004128', component.options)
    } else {
      api.reload('66004128', component.options)
    }
    module.hot.accept("./AddTeamMemberModal.vue?vue&type=template&id=66004128&", function () {
      api.rerender('66004128', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamMembers/AddTeamMemberModal.vue"
export default component.exports